import { disallow } from 'feathers-hooks-common';
import { withShipmentSearch } from 'src/feathers/hooks';

export default {
  before: {
    all: [],
    find: [withShipmentSearch],
    get: [disallow()],
    create: [disallow()],
    update: [disallow()],
    patch: [disallow()],
    remove: [disallow()]
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
};
